import { render, staticRenderFns } from "./calendarview.vue?vue&type=template&id=72988d31&scoped=true&"
import script from "./calendarview.vue?vue&type=script&lang=js&"
export * from "./calendarview.vue?vue&type=script&lang=js&"
import style0 from "./calendarview.vue?vue&type=style&index=0&id=72988d31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72988d31",
  null
  
)

export default component.exports